<template>
  <div>
    <div class="vx-row mt-3 mb-3 flex justify-between">
      <ul class="heading-ul mb-3">
        <li>
          <router-link :to="{ name: 'View Business Entity', params: { id: entityId } }">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
          </router-link>
        </li>
        <li>
          <h3>{{ $t("entity.label.agreement") }}</h3>
        </li>
      </ul>
      <vs-button
        color="primary"
        icon-pack="feather"
        icon="icon-plus"
        class="truncate"
        type="border"
        @click="openAgreementPopup"
        size="small"
        >{{ $t("entity.label.create_agreement") }}</vs-button
      >
    </div>
    <vx-card>
      <vs-table
        :max-items="descriptionItems[0]"
        class="mt-3"
        :data="agreementDetails"
        description
        :description-items="descriptionItems"
        description-title="Registries"
        description-connector="of"
        description-body="Pages"
        @selected="handleSelected"
      >
        <template slot="header">
          <!-- ADD NEW -->
        </template>
        <template slot="thead">
          <vs-th>{{ $t("entity.label.contract_effect_date") }}</vs-th>
          <vs-th>{{ $t("entity.label.agreement_date") }}</vs-th>
          <vs-th>{{ $t("entity.label.agreement_status") }}</vs-th>
          <vs-th>{{ $t("entity.label.agreement_type") }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" :data="tr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.effectDay">{{ tr.effectDay }}</vs-td>
            <vs-td :data="tr.endDate">{{ tr.endDate }}</vs-td>
            <vs-td :data="tr.agreementStatus">{{ tr.agreementStatus }}</vs-td>
            <vs-td :data="tr.planCode">{{ tr.planCode }}</vs-td>
            <!-- <vs-td class="whitespace-no-wrap">
              <div class="container_img">
                <img
                  class="icon_row"
                  src="@/assets/images/icons/Edit.png"
                  alt="Edit"
                  title="Edit"
                  @click.stop="editData(entity.id)"
                />

                <img
                  class="icon_row"
                  src="@/assets/images/icons/Credit.png"
                  title="Update Credit"
                  @click.stop="updateCraditModel(entity.id)"
                  alt="Update Credit"
                />

                <img
                  class="icon_row"
                  src="@/assets/images/icons/AddTicket.png"
                  title="Add Ticket"
                  @click.stop="showTicketForm(entity.id)"
                  alt="Add Ticket"
                />
              </div>
            </vs-td> -->
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('entity.label.partner_agreement')"
        :active.sync="AgreementPopup"
        class="popup-close"
      >
        <form>
          <div class="vx-row">
            <div class="vx-col sm:w-full w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("entity.label.contract_effect_date")
                }}</small>
                <datepicker
                  :placeholder="$t('placeholder.label.SelectDate')"
                  v-model="agreement.effectDay"
                  class="mb-2 font-semibold"
                />
              </div>
            </div>
            <div class="vx-col sm:w-full w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("entity.label.agreement_date")
                }}</small>
                <datepicker
                  :placeholder="$t('placeholder.label.SelectDate')"
                  v-model="agreement.endDate"
                  class="mb-2 font-semibold"
                />
              </div>
            </div>
            <div class="vx-col sm:w-full w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("entity.label.agreement_status")
                }}</small>
                <v-select
                  label="mCodeValue"
                  :options="agreementTemplate.agreementTypes"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(obj) => obj.mCodeValue"
                  v-model="agreement.agreementStatus"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                />
              </div>
            </div>
            <div class="vx-col sm:w-full w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("entity.label.agreement_type")
                }}</small>
                <v-select
                  label="mCodeValue"
                  :options="agreementTypeOptions"
                  v-model="agreement.planCode"
                  :reduce="(obj) => obj.mCodeValue"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                />
              </div>
            </div>
          </div>
          <div
            v-if="
              agreement.planCode == 'Dealer' || agreement.planCode == 'Partner'
            "
          >
            <h3>{{$t("entity.label.Commission")}}</h3>
            <div class="vx-row">
              <div class="vx-col sm:w-full lg:w-1/2">
                <div class="dropdown-with-label">
                  <small class="date-label">{{ $t("entity.label.CommisionType") }}</small>
                  <v-select
                    label="label"
                    :options="commisionOptions"
                    v-model="commissionTpe"
                    :reduce="(obj) => obj.value"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  />
                </div>
              </div>
              <div class="vx-col sm:w-full lg:w-1/2">
                <vs-input
                  :label="$t('entity.label.Value')"
                  type="number"
                  :max="100"
                  class="w-full font-semibold mb-2 starlabel"
                  v-model="commissionValue"
                />
              </div>
            </div>
          </div>
          <div class="center mt-4">
            <span class="ml-1 mr-1" v-if="showConfigureBtn">
              <vs-button
                @click="initConfigure"
                class="footerButton-next mb-3"
                style="top: 0px; width: 400px"
                >{{$t("entity.label.Configure")}} {{ agreement.planCode }} {{$t("entity.label.Agreement")}}</vs-button
              >
            </span>
            <span class="ml-1 mr-1">
              <vs-button
                @click="createAgreement"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("entity.label.submit") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 20px"></div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('entity.label.Configure')"
        :active.sync="AgreementConfugurePopup"
        class="popup-close"
      >
        <div class="vx-row">
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <div class="dropdown-with-label">
              <small class="date-label">{{$t("entity.label.Type")}}</small>
              <v-select
                label="text"
                :options="configureTypeOptions"
                v-model="config.type"
                :reduce="(obj) => obj.value"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full"
              />
            </div>
          </div>
          <div
            class="vx-col sm:w-full w-full lg:w-1/2"
            v-if="agreement.planCode == 'Roaming'"
          >
            <div class="dropdown-with-label">
              <small class="date-label">{{$t("entity.label.TAP_version")}}</small>
              <v-select
                label="text"
                :options="tapVersionOptions"
                v-model="config.tapVersion"
                :reduce="(obj) => obj.value"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full"
              />
            </div>
          </div>
        </div>
        <div class="vx-row" v-if="agreement.planCode == 'Roaming'">
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <vs-input
              :label="$t('entity.label.TAP_In_sequence')"
              type="text"
              class="w-full font-semibold mb-2 starlabel"
              v-model="config.tapInSequence"
            />
          </div>
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <vs-input
              :label="$t('entity.label.TAP_Out_sequence')"
              type="text"
              class="w-full font-semibold mb-2 starlabel"
              v-model="config.tapOutSequence"
            />
          </div>
        </div>
        <div class="vx-row" v-if="agreement.planCode == 'Roaming'">
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <vs-input
              :label="$t('entity.label.RAP_In_Sequence')"
              type="text"
              class="w-full font-semibold mb-2 starlabel"
              v-model="config.rapInSequence"
            />
          </div>
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <vs-input
              :label="$t('entity.label.RAP_Out_Sequence')"
              type="text"
              class="w-full font-semibold mb-2 starlabel"
              v-model="config.rapOutSequence"
            />
          </div>
        </div>
        <div class="vx-row" v-if="agreement.planCode == 'Roaming'">
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <vs-input
              :label="('entity.label.NRTRDE_In_Sequence')"
              type="text"
              class="w-full font-semibold mb-2 starlabel"
              v-model="config.nrtInSequence"
            />
          </div>
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <vs-input
              :label="('entity.label.NRTRDE_Out_Sequence')"
              type="text"
              class="w-full font-semibold mb-2 starlabel"
              v-model="config.nrtOutSequence"
            />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{$t("entity.label.In")}}
                {{ agreement.planCode == "Roaming" ? "Roaming" : "Settlement" }}
                {{$t("entity.label.PLan")}}<span class="required"> *</span></small
              >
              <v-select
                label="planDesc"
                :options="ReportsData.PlanpriceDatas"
                v-model="config.inRoaminPlan"
                :placeholder="$t('placeholder.label.SelectOne')"
                :reduce="(obj) => obj.priceId"
                @input="planName"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mt-1 mb-2"
              >
              </v-select>
            </div>
          </div>
          <div class="vx-col sm:w-full w-full lg:w-1/2">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{$t("entity.label.Out")}}
                {{ agreement.planCode == "Roaming" ? "Roaming" : "Settlement" }}
                {{$t("entity.label.PLan")}}<span class="required"> *</span></small
              >
              <v-select
                label="planDesc"
                :options="ReportsData.PlanpriceDatas"
                v-model="config.outRoamingPlan"
                :reduce="(obj) => obj.priceId"
                :placeholder="$t('placeholder.label.SelectOne')"
                @input="planName"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mt-1 mb-2"
              >
              </v-select>
            </div>
          </div>
        </div>
        <div class="center mt-4 mb-4">
          <span class="ml-1 mr-1">
            <vs-button
              @click="closeConfigurePopup"
              class="footerButton-next"
              style="top: 0px"
              >{{$t("entity.label.Cancel")}}</vs-button
            >
          </span>
          <span class="ml-1 mr-1">
            <vs-button
              @click="handleConfigure"
              class="footerButton-next"
              style="top: 0px"
              >{{$t("entity.label.Save")}}</vs-button
            >
          </span>
        </div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
const agreementObj = {
  effectDay: null,
  endDate: null,
  agreementStatus: "",
  planCode: "",
};
const configObj = {
  type: "",
  tapVersion: "",
  tapInSequence: "",
  tapOutSequence: "",
  rapInSequence: "",
  rapOutSequence: "",
  nrtInSequence: "",
  nrtOutSequence: "",
  inRoaminPlan: "",
  outRoamingPlan: "",
};
const ReportsEmptyObj = {
  templateName: "",
  numberOfFields: "",
  isHeader: "",
  headerRecordType: "",
  locale: "en",
  eventRecordType: [],
  // eventRecordType: "",
  delimited: "",
  delimiter: "",
  columns: [],
};
import moment from "moment";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import { mapState } from "vuex";
export default {
  components: {
    vSelect,
    Datepicker,
  },
  data() {
    return {
      descriptionItems: [5, 10, 15],
      agreementDetails: [
        {
          effectDay: "12 March 2024",
          endDate: "09 March 2024",
          agreementStatus: "Pending",
          planCode: "Roaming",
          id: "a",
        },
        {
          effectDay: "16 Feb 2024",
          endDate: "13 Feb 2024",
          agreementStatus: "Signed",
          planCode: "Interconnect",
          id: "b",
        },
        {
          effectDay: "26 March 2024",
          endDate: "20 March 2024",
          agreementStatus: "Pending",
          planCode: "Interconnect",
          id: "c",
        },
        {
          effectDay: "01 April 2024",
          endDate: "23 March 2024",
          agreementStatus: "Signed",
          planCode: "Roaming",
          id: "d",
        },
      ],
      commisionOptions: [
        {
          label: "Percent",
          value: "Percent",
        },
        {
          label: "flat",
          value: "flat",
        },
      ],
      commissionValue: 0,
      commissionTpe: "",
      configArr: [],
      config: configObj,
      Reports: ReportsEmptyObj,
      agreement: agreementObj,
      agreementTypeOptions: [
        {
          id: 1,
          mCodeValue: "Roaming",
        },
        {
          id: 2,
          mCodeValue: "Interconnect",
        },
        {
          id: 3,
          mCodeValue: "Dealer",
        },
        {
          id: 4,
          mCodeValue: "Partner",
        },
      ],
      configureTypeOptions: [
        { text: "Incoming", value: "Incoming" },
        { text: "Outgoing", value: "Outgoing" },
      ],
      selectedType: "",
      tapVersionOptions: [
        { text: "3.10", value: "3.10" },
        { text: "3.11", value: "3.11" },
        { text: "3.12", value: "3.12" },
      ],
      AgreementPopup: false,
      AgreementConfugurePopup: false,
      curAgreementId: "",
      entityId: "",
    };
  },
  computed: {
    agreementTemplate() {
      return this.$store.getters["entity/getAgreementsTemplate"];
    },

    ...mapState({
      ReportsData: (state) => state.usageRating.GetUsageTemplate,
    }),
    showConfigureBtn() {
      if (
        this.agreement.planCode.toLowerCase() == "roaming" ||
        this.agreement.planCode.toLowerCase() == "interconnect"
      ) {
        return true;
      } else return false;
    },
  },
  methods: {
    initConfigure() {
      this.curAgreementId = Date.now() + Math.random();
      this.AgreementPopup = false;
      this.AgreementConfugurePopup = true;
    },
    closeConfigurePopup() {
      this.AgreementConfugurePopup = false;
      this.AgreementPopup = true;
    },
    openAgreementPopup() {
      this.agreement = agreementObj;
      this.config = configObj;
      this.AgreementPopup = true;
    },
    handleConfigure() {
      let obj = {
        ...this.config,
        id: this.curAgreementId,
      };
      this.configArr.push(obj);
      this.AgreementConfugurePopup = false;
      this.AgreementPopup = true;
      // this.config = configObj;
    },
    async createAgreement() {
      try {
        const agreementPostObj = {
          effectDay: moment(this.agreement.effectDay).format("DD MMMM YYYY"),
          locale: "en",
          agreementStatus: this.agreement.agreementStatus,
          planCode: this.agreement.planCode,
          endDate: moment(this.agreement.endDate).format("DD MMMM YYYY"),
          // dateFormat: "dd MMMM yyyy",
        };
        this.agreementDetails = this.agreementDetails.filter(
          (el) => el.id !== this.curAgreementId
        );
        this.agreementDetails.push({
          ...agreementPostObj,
          id: this.curAgreementId,
        });
        this.config = configObj;
        this.curAgreementId = "";
        this.AgreementPopup = false;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    handleSelected(item) {
      this.curAgreementId = item.id;
      this.agreement = item;
      let findObj = this.configArr.find((el) => el.id === item.id);
      this.config = { ...findObj };
      if (this.showConfigureBtn) {
        this.AgreementConfugurePopup = true;
      } else {
        this.AgreementPopup = true;
      }
    },
    planName() {},
  },

  async mounted() {
    await this.$store.dispatch("entity/setAgreementsTemplate");
    await this.$store.dispatch("usageRating/setUsageTemplate");
    this.entityId = this.$route.params.entityId;
  },
};
</script>

<style scoped></style>
